import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SportsMenuPage } from './sports-menu-page';
import { SportsDashboardComponent } from '../sports-dashboard/sports-dashboard';
import { BaselineSharedModule } from 'baseline-lib';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { LiveSportsDashboardComponent } from '../live-sports-dashboard/live-sports-dashboard';


@NgModule({
  declarations: [
    SportsMenuPage,
    SportsDashboardComponent,
    LiveSportsDashboardComponent,
  ],
  imports: [
    BaselineSharedModule,
    TranslateModule,
    SharedModule,
    IonicPageModule.forChild(SportsMenuPage),
  ],
  exports:[
    SportsMenuPage,
    SportsDashboardComponent,
    LiveSportsDashboardComponent
  ]
})
export class SportsMenuPageModule {}



// WEBPACK FOOTER //
// ./src/app/sports/sports-menu-page/sports-menu-page.module.ts